
 
  document.addEventListener("DOMContentLoaded", function () {
    const itemsPerPage = 12;
    const paginationContainer = document.getElementById("pagination-container");
    let currentPage = 1;

    // --- Elements for the new disabling function ---
    const productsDropdownWrapper = document.querySelector('.dropdown-list[data-select="products"]').closest('.custom-select');
    const productsSelectedDisplay = productsDropdownWrapper.querySelector('.selected');
    
    // Get the default "All Products" option to reset the display text
    const allProductsItem = productsDropdownWrapper.querySelector('li[data-value="all-products"]');
    const allProductsText = allProductsItem ? allProductsItem.querySelector('.option-title').innerText : 'All Products';
    // --------------------------------------------------

    function getVisibleItems() {
      return Array.from(document.querySelectorAll(".paginate:not(.hide)"));
    }

    function showPage(page) {
      currentPage = page;
      const visibleItems = getVisibleItems();
      const start = (page - 1) * itemsPerPage;
      const end = start + itemsPerPage;

      // Hide all items first
      document.querySelectorAll(".paginate").forEach(item => {
        item.style.display = "none";
      });

      // Show visible items for this page
      visibleItems.forEach((item, index) => {
        if (index >= start && index < end) {
          item.style.display = "block";
        }
      });

      renderPaginationControls(visibleItems.length);
    }

    function renderPaginationControls(totalVisible) {
      paginationContainer.innerHTML = "";
      const totalPages = Math.ceil(totalVisible / itemsPerPage);

      if (totalPages <= 1) return;

      // Prev button
      const prevBtn = document.createElement("button");
      prevBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Component_1.png?v=1758516497">';
      prevBtn.disabled = currentPage === 1;
      prevBtn.addEventListener("click", () => showPage(currentPage - 1));
      paginationContainer.appendChild(prevBtn);

      // Numbered buttons
      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement("button");
        btn.innerText = i;
        btn.className = (i === currentPage) ? "active" : "";
        btn.addEventListener("click", () => showPage(i));
        paginationContainer.appendChild(btn);
      }

      // Next button
      const nextBtn = document.createElement("button");
      nextBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Vector.png?v=1758512062">';
      nextBtn.disabled = currentPage === totalPages;
      nextBtn.addEventListener("click", () => showPage(currentPage + 1));
      paginationContainer.appendChild(nextBtn);
    }

    function refreshPagination() {
      showPage(1);
    }


    // ------------------------------------
    // DROPDOWN FILTER SCRIPT (integrated)
    // ------------------------------------
    // Shared across all select boxes
    const selectedValues = {
      collections: null,
      products: null,
      cups: null,
    };

    const imageItem = document.querySelectorAll('.content-sizing-area__result-item');
    const inserts = ['ultra-boost-inserts®', 'ultra-boost-lite-inserts', 'demi-boost-inserts®', 'demi-boost-lite-inserts', 'invisible-lift-inserts®', 'subtle-lift-inserts', 'micro-lift-inserts-2-pairs'];
    const bras = ['magic-padded-sticky-bra', 'boomba®-sticky-bra', 'demi-sticky-bra', 'boomba-invisibra®'];
    const tapes = ['body-tape', 'reusable-body-tape', 'magic-breast-lift'];

    function resetCollection() {
      imageItem.forEach(item => {
        item.classList.remove('hide', 'selected');
      });
    }

    // Helper function to set the product dropdown to its 'All Products' default state
    function resetProductDropdownToAll() {
      selectedValues.products = null; // Reset the product filter value
      
      // Visually reset the selected display
      productsSelectedDisplay.innerHTML = `<span>${allProductsText}</span>`;

      // Reset active class on product options
      productsDropdownWrapper.querySelectorAll('li').forEach(item => {
        item.classList.remove('active');
        item.querySelector('.radio-circle')?.classList.remove('active');
      });
      
      // Set 'all-products' as active
      if (allProductsItem) {
        allProductsItem.classList.add('active');
        allProductsItem.querySelector('.radio-circle')?.classList.add('active');
      }
    }
    

    /**
     * NEW: Function to manage the state of the Products dropdown (enable/disable)
     * @param {boolean} shouldDisable 
     */
    function toggleProductDropdownState(shouldDisable) {
        // Find the product select box using the wrapper variable defined earlier
        if (shouldDisable) {
            productsDropdownWrapper.classList.add('disabled');
            productsSelectedDisplay.style.pointerEvents = 'none';
            
            // Also reset the selected product value to null when disabling
            resetProductDropdownToAll();

        } else {
            productsDropdownWrapper.classList.remove('disabled');
            productsSelectedDisplay.style.pointerEvents = '';
        }
        
        // Ensure the page updates after a potential change in selectedValues.products
        applyFilters();
    }



    function updateAvailableCups() {
    const { collections, products } = selectedValues;
    const availableSizes = new Set();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const size = item.getAttribute('data-size');
      let show = true;

      // ✅ Apply collection filter
      if (collections === 'adhesive-inserts') {
        show = inserts.includes(category);
      } else if (collections === 'body-tapes') {
        show = tapes.includes(category);
      } else if (collections === 'adhesive-bras') {
        show = bras.includes(category);
      }

      // ✅ Apply product filter (same logic as in applyFilters)
      if (show && products) {
        if (products === 'ultra-boost') {
          show = category === 'ultra-boost-inserts®';
        }
        else if (products === 'ultra-boost-lite') {
          show = category === 'ultra-boost-lite-inserts';
        }
        else if (products === 'demi-boost') {
          show = category === 'demi-boost-inserts®';
        }
        else if (products === 'demi-boost-lite-inserts') {
          show = category === 'demi-boost-lite-inserts';
        }
        else if (products === 'invisible-lift') {
          show = category === 'invisible-lift-inserts®';
        }
        else if (products === 'subtle-lift-inserts') {
          show = category === 'subtle-lift-inserts';
        }
        else if (products === 'micro-lift-inserts') {
          show = category === 'micro-lift-inserts-2-pairs';
        }
        else if (products === 'magic-padded-sticky-bra') {
          show = category === 'magic-padded-sticky-bra';
        }
        else if (products === 'boomba-sticky-bra') {
          show = category === 'boomba®-sticky-bra';
        }
        else if (products === 'demi-sticky-bra') {
          show = category === 'demi-sticky-bra';
        }
        else if (products === 'boomba-invisibra') {
          show = category === 'boomba®-invisibra';
        }
        else if (products === 'body-tape') {
          show = category === 'body-tape';
        }
        else if (products === 'reusable-body-tape') {
          show = category === 'reusable-body-tape';
        }
        else if (products === 'magic-breast-lift') {
          show = category === 'magic-breast-lift';
        }
      }
        
      // If collections is 'all-collections', we ignore any product filter when checking size availability.
      // This ensures 'all-collections' doesn't artificially limit available sizes based on a disabled 'products' filter.
      if (collections === 'all-collections' && products) {
        show = true; // Override product filter for size collection if collection is 'all'
      }


      // ✅ Collect sizes that are still valid
      if (show && size) {
        availableSizes.add(size);
      }
    });

    // ✅ Update dropdown options
    const cupDropdown = document.querySelector('.dropdown-list[data-select="cups"]');
    if (cupDropdown) {
      cupDropdown.querySelectorAll('li').forEach(li => {
        const cupVal = li.getAttribute('data-value');
        
        // Exclude the 'all' option from disabling based on available sizes
        if (cupVal === 'all') {
          li.classList.remove('disabled');
          li.style.pointerEvents = "";
          li.style.opacity = "1";
          li.style.color = "#222";
          return;
        }

        if (!availableSizes.has(cupVal)) {
          li.classList.add('disabled');
          li.style.pointerEvents = "none";
          li.style.opacity = "0.5";
          li.style.color = "#d4d4d4";
        } else {
          li.classList.remove('disabled');
          li.style.pointerEvents = "";
          li.style.opacity = "1";
          li.style.color = "#222";
        }
      });
    }
  }


    function applyFilters() {
      resetCollection();

      const { collections, products, cups } = selectedValues;
      let hasMatch = false;

      updateAvailableCups();

      imageItem.forEach(item => {
        const category = item.getAttribute('data-category');
        const categorySize = item.getAttribute('data-size');
        let show = true;

        // 1. COLLECTIONS filter
        if (collections === 'adhesive-inserts') {
          show = inserts.includes(category);
        } else if (collections === 'body-tapes') {
          show = tapes.includes(category);
        } else if (collections === 'adhesive-bras') {
          show = bras.includes(category);
        }

        // 2. PRODUCTS filter (Only apply if collections is NOT 'all-collections' AND a product is selected)
        // Note: products is set to null when collections is 'all-collections' due to the new logic.
        if (show && products && collections !== 'all-collections') {
          if (products === 'ultra-boost') {
            show = category === 'ultra-boost-inserts®';
          }
          else if (products === 'ultra-boost-lite') {
            show = category === 'ultra-boost-lite-inserts';
          }
          else if (products === 'demi-boost') {
            show = category === 'demi-boost-inserts®';
          }
          else if (products === 'demi-boost-lite-inserts') {
            show = category === 'demi-boost-lite-inserts';
          }
          else if (products === 'invisible-lift') {
            show = category === 'invisible-lift-inserts®';
          }
          else if (products === 'subtle-lift-inserts') {
            show = category === 'subtle-lift-inserts';
          }
          else if (products === 'micro-lift-inserts') {
            show = category === 'micro-lift-inserts-2-pairs';
          }
          else if (products === 'magic-padded-sticky-bra') {
            show = category === 'magic-padded-sticky-bra';
          }
          else if (products === 'boomba-sticky-bra') {
            show = category === 'boomba®-sticky-bra';
          }
          else if (products === 'demi-sticky-bra') {
            show = category === 'demi-sticky-bra';
          }
          else if (products === 'boomba-invisibra') {
            show = category === 'boomba-invisibra®';
          }
          else if (products === 'body-tape') {
            show = category === 'body-tape';
          }
          else if (products === 'reusable-body-tape') {
            show = category === 'reusable-body-tape';
          }
          else if (products === 'magic-breast-lift') {
            show = category === 'magic-breast-lift';
          }
        }

        // 3. CUPS filter
        if (show && cups && cups !== 'all') {
          // Simplified cup filter logic (based on my previous recommendation)
          show = categorySize === cups;
        }

        if (show) {
          item.classList.remove('hide');
          item.classList.add('selected');
          hasMatch = true;
        } else {
          item.classList.add('hide');
          item.classList.remove('selected');
        }
      });

      // Show/hide "no results" message
      const noResultEl = document.querySelector('.no-results-message');
      if (noResultEl) {
        noResultEl.style.display = hasMatch ? 'none' : 'block';
      }

      refreshPagination();
    }

    document.querySelectorAll('.custom-select').forEach(selectBox => {
      const selected = selectBox.querySelector('.selected');
      const dropdownTypes = ['collections', 'products', 'cups'];

      // Toggle dropdown
      selected.addEventListener('click', () => {
        // Do not allow opening if the custom-select is disabled
        if (selectBox.classList.contains('disabled')) return;

        document.querySelectorAll('.custom-select').forEach(otherBox => {
          if (otherBox !== selectBox) {
            otherBox.classList.remove('open');
          }
        });
        selectBox.classList.toggle('open');
      });

      dropdownTypes.forEach(type => {
        const dropdown = selectBox.querySelector(`.dropdown-list[data-select="${type}"]`);
        if (!dropdown) return;

        const items = dropdown.querySelectorAll('li');
        items.forEach(item => {
          item.addEventListener('click', () => {
            // Prevent action if the list item itself is disabled (for cup sizes)
            if (item.classList.contains('disabled')) return;
            
            const value = item.getAttribute('data-value');
            const title = item.querySelector('.option-title')?.innerText || '';
            const img = item.querySelector('img')?.src;

            // Save selected value
            selectedValues[type] = value;
            
            // ------------------------------------
            // ✅ NEW LOGIC: COLLECTIONS FILTER HANDLING
            // ------------------------------------
            if (type === 'collections') {
                const isAllCollections = value === 'all-collections';
                
                // 1. Enable/Disable Products Dropdown
                toggleProductDropdownState(isAllCollections);
                
                // 2. Product Option Filtering (Existing Logic)
                const insertsCat = ['all-products', 'all-inserts', 'ultra-boost', 'ultra-boost-lite', 'demi-boost', 'demi-boost-lite-inserts', 'invisible-lift', 'subtle-lift-inserts', 'micro-lift-inserts'];
                const brasCat = ['all-products', 'all-bras', 'magic-padded-sticky-bra', 'boomba-sticky-bra', 'demi-sticky-bra', 'boomba-invisibra'];
                const tapesCat = ['all-products', 'all-tapes', 'body-tape', 'reusable-body-tape', 'magic-breast-lift'];
                const allCat = ['all-products', 'all-inserts', 'ultra-boost', 'ultra-boost-lite', 'demi-boost', 'demi-boost-lite-inserts', 'invisible-lift', 'subtle-lift-inserts', 'micro-lift-inserts', 'all-bras', 'magic-padded-sticky-bra', 'boomba-sticky-bra', 'demi-sticky-bra', 'boomba-invisibra', 'all-tapes', 'body-tape', 'reusable-body-tape', 'magic-breast-lift'];

                const productDropdown = document.querySelector('.dropdown-list[data-select="products"]');

                if (productDropdown) {
                  const productItems = productDropdown.querySelectorAll('li');

                  productItems.forEach(productItem => {
                    productItem.classList.remove('hide'); // Show everything initially

                    const productValue = productItem.getAttribute('data-value');
                    let validList = [];

                    if (value === 'adhesive-inserts') {
                      validList = insertsCat;
                    } else if (value === 'adhesive-bras') {
                      validList = brasCat;
                    } else if (value === 'body-tapes') {
                      validList = tapesCat;
                    } else if (value === 'all-collections') {
                      validList = allCat;
                    }

                    // Only hide items if there's a match group
                    if (validList.length && !validList.includes(productValue)) {
                      productItem.classList.add('hide');
                    }
                  });
                }
            }
            // ------------------------------------

            // Update visual state of dropdown
            items.forEach(i => {
              i.classList.remove('active');
              i.querySelector('.radio-circle')?.classList.remove('active');
            });

            item.classList.add('active');
            item.querySelector('.radio-circle')?.classList.add('active');

            // Update selected display
            selected.innerHTML = img
              ? `<span>${title}</span>`
              : `<span>${title}</span>`;

            applyFilters();
            console.log('Current Selections:', selectedValues);
            selectBox.classList.remove('open');
          });
        });
      });
    });

    // Close dropdown1 on outside click
    document.addEventListener('click', e => {
      document.querySelectorAll('.custom-select').forEach(box => {
        if (!box.contains(e.target)) {
          box.classList.remove('open');
        }
      });
    });

    // Initial load
    showPage(1);
    updateAvailableCups();
    
    // NEW: Initial check to ensure 'All Collections' is selected and 'All Products' is disabled on load
    // Assuming 'all-collections' is the default active state in the HTML
    if (document.querySelector('li[data-value="all-collections"]')?.classList.contains('active')) {
      toggleProductDropdownState(true);
    }



    document.querySelector('.reset-btn')?.addEventListener('click', () => {
      // Reset selected values
      selectedValues.collections = null;
      selectedValues.products = null;
      selectedValues.cups = null;
      
      const allCollectionsItem = document.querySelector('li[data-value="all-collections"]');
      // Set all-collections as the active value in selectedValues for correct filter behavior
      if (allCollectionsItem) {
        selectedValues.collections = allCollectionsItem.getAttribute('data-value');
      }

      // Show/hide 'all' product options logic
      const allInserts = document.querySelector('li[data-value="all-inserts"]');
      const allBras = document.querySelector('li[data-value="all-bras"]');
      const allTapes = document.querySelector('li[data-value="all-tapes"]');

      // Reset visual states of dropdowns
      document.querySelectorAll('.custom-select').forEach(selectBox => {
        const selected = selectBox.querySelector('.selected');
        const defaultText = selected.getAttribute('data-placeholder') || 'Select';
        const selectType = selectBox.querySelector('.dropdown-list').getAttribute('data-select');

        // Reset selected HTML
        selected.innerHTML = `<span>${defaultText}</span>`;

        // Remove active class from all dropdown items
        selectBox.querySelectorAll('li').forEach(item => {
          item.classList.remove('active');
          item.querySelector('.radio-circle')?.classList.remove('active');
          item.classList.remove('hide'); // Make sure all options show up again
        });
        
        // Set the "All" item as active for all dropdowns
        let defaultActiveItem;
        if (selectType === 'collections') {
          defaultActiveItem = selectBox.querySelector('li[data-value="all-collections"]');
        } else if (selectType === 'products') {
          defaultActiveItem = selectBox.querySelector('li[data-value="all-products"]');
        } else if (selectType === 'cups') {
          defaultActiveItem = selectBox.querySelector('li[data-value="all"]');
        }
        
        if (defaultActiveItem) {
          defaultActiveItem.classList.add('active');
          defaultActiveItem.querySelector('.radio-circle')?.classList.add('active');
        }
      });


      // Re-hide the collection-specific 'All Products' options
      allInserts.classList.add('hide');
      allBras.classList.add('hide');
      allTapes.classList.add('hide');
      
      // ✅ NEW: Disable the Products dropdown on reset
      toggleProductDropdownState(true);

      // Show all filtered results
      applyFilters();
    });


  });
